import Setting from 'assets/icons/setting.svg';
import Combain from 'assets/icons/combain.svg';
import Location from 'assets/icons/location.svg';
import CloudCode from 'assets/icons/cloud-code.svg';
import CloudUpload from 'assets/icons/cloud-upload.svg';
import MoveToFolder from 'assets/icons/move-to-folder.svg';

const gap = { gap: { tablet: '10px', laptop: '20px' } };

export const cloudMigrationTechExpertData = {
  title: 'Комплексные услуги по миграции в облако',
  titleProps: { maxW: { mobile: '350px', tablet: '400px', laptop: '900px' } },

  cardsData: [
    {
      title: 'Миграция ИТ‑инфраструктуры в облако',
      tabIcon: CloudUpload,
      content: [
        'Переносим серверы, сети и системы хранения в облачные среды с минимальными простоями.',
        ` •	оценка текущей инфраструктуры; <br />
          •	подбор частного, публичного или гибридного (Private/Public/Hybrid) облака; <br />
          •	настройка виртуальных машин, сетей и хранилищ.`,
        'Это позволяет бизнесу работать непрерывно и снизить риски простоев',
      ],
      gap,
    },
    {
      title: 'Перенос приложений и корпоративных систем',
      tabIcon: MoveToFolder,
      content: [
        'Переносим ПО, системы управления предприятием (ERP) и особые бизнес-системы в облако без остановки работы.',
        ` •	Экспорт, преобразование и импорт данных; <br />
          •	Адаптация устаревшего (legacy) кода; <br />
          •	Нагрузочное тестирование и проверка работоспособности.`,
        'Это гарантирует безопасность данных и непрерывность бизнес-процессов.',
      ],
      gap,
    },
    {
      title: 'Улучшение архитектуры при переходе',
      tabIcon: Setting,
      content: [
        'Анализируем инфраструктуру и адаптируем её под облачные сценарии.',
        ` •	Аудит и оценка текущей архитектуры; <br />
          •	Проектирование целевой архитектуры; <br />
          •	Рекомендации по повышению производительности.`,
        'Это ускоряет работу служб и снижает расходы на содержание ИТ-систем.',
      ],
      gap,
    },
    {
      title: 'Внедрение гибридной и мультиоблачной архитектуры',
      tabIcon: Combain,
      content: [
        'Настраиваем совместную работу разных облаков и собственных (on-prem) систем для гибкости.',
        ` •	Интеграция облаков и локальных серверов; <br />
          •	Настройка резервирования и отказоустойчивости; <br />
          •	Тестирование совместимости систем.`,
        'Это позволяет расширять бизнес и быть независимым от конкретной площадки.',
      ],
      gap,
    },
    {
      title: 'Переход на отечественные облачные решения',
      tabIcon: Location,
      content: [
        'Помогаем связывать платформы и соблюдать требования законодательства.',
        ` •	Аудит и выбор локального облака; <br />
          •	Миграция систем и данных; <br />
          •	Настройка безопасности и соответствия нормам (комплаенса).`,
        'Это обеспечивает соблюдение нормативов и защиту данных в соответствии с законами.',
      ],
      gap,
    },
    {
      title: 'Разработка и перенос сервисов в облако',
      tabIcon: CloudCode,
      content: [
        'Обеспечиваем корректную работу бизнес‑сервисов и приложений после миграции.',
        ` •	Адаптация сервисов под облачную среду; <br />
          •	Интеграция с корпоративными системами; <br />
          •	Проверка стабильности и производительности.`,
        'Это позволяет бизнесу запускать сервисы быстрее и без перебоев.',
      ],
      gap,
    },
  ],
};
